// extracted by mini-css-extract-plugin
export default {"Search":"SearchContainer_Search__lhbPI"};